import { CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Modal, Switch } from "antd"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { delTarget, getInfoTarget, getListTarget, ITarget } from "../../../../../api/target/targetApi"
import ModalDeleteManager from "../../../../../components/ModalDeleteManager"
import useLoading from "../../../../../hook/useLoading"
import useThrottle from "../../../../../hook/useThrottle"
import useToast from "../../../../../hook/useToast"
import { selectorPermission } from "../../../../../store/slices/permissionSlice"
import { checkDisabledPermission, getUserPermissions } from "../../../../../until"
// import ModalAddCreateSMSProvider from "./ModalAddCreateSMSProvider"
// import ModalUpdateTarget from "./ModalUpdateSupplierManagement"

import '../../styles.scss'
import ModalAddCreateZNSProvider from "./ModalAddCreateZNSProvider"
import { activeProvider, deleteProvider, getInfoZnsProvider, getListZnsProvider, IBrandConfigsZNS, IProvider } from "../../../../../api/integrationProvider/integrationProvidersApi"
import { NO_DATA } from "../../../../../env"
import ModalUpdateCreateZNSProvider from "./ModalUpdateCreateZNSProvider"

interface ModalProps {
    isOpen: boolean
    closeModal: () => void
    gListZnsConfig?: () => void
}
const ModalZNSSupplierManagement: React.FC<ModalProps> = ({
    isOpen, closeModal, gListZnsConfig
}) => {

    const pushToast = useToast();
    const pushLoading = useLoading()
    const permissionSlice = useSelector(selectorPermission)
    const { add, edit, delete: isDelete, upload, download, share, access } = getUserPermissions(permissionSlice, location.pathname)

    const [isModalAddZNSProvider, setIsModalAddZNSProvider] = useState(false)
    const [isModalUpdateZNSProvider, setIsModalUpdateZNSProvider] = useState(false)
    const [isModalDeleteZNSProvider, setIsModalDeleteZNSProvider] = useState(false)


    const [listProvider, setListProvider] = useState<IBrandConfigsZNS[]>([])
    const [infoProvider, setInfoProvider] = useState<IBrandConfigsZNS>()

    const [selectedId, setSelectedId] = useState<number | undefined>()

    //thiếu đổi từ API mục tiêu sang SMS
    const gListZnsProvider = async () => {
        const result = await getListZnsProvider()
        if (result?.status) {
            setListProvider(result.data)
        } else {
            pushToast(result?.message, "warning")
        }
    }

    const gInfoProvider = useThrottle(async (id: number) => {
        pushLoading(true)
        const result = await getInfoZnsProvider(id)
        if (result?.status) {
            setInfoProvider(result.data)
            setIsModalUpdateZNSProvider(true)
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)


    const handelActiveProvider = useThrottle(async (id: number) => {
        pushLoading(true)
        const result = await activeProvider(id)
        if (result?.status) {
            gListZnsProvider()
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            setIsModalAddZNSProvider(false)
            pushToast(message, "success")
            gListZnsProvider()
        } else {
            pushToast(message, "error")
        }
    }

    const onSubmitFormModalUpdate = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            pushToast(message, "success")
            gListZnsProvider()
            setIsModalUpdateZNSProvider(false)
            gListZnsConfig?.()

        } else {
            pushToast(message, "error")
        }
    }

    const openModalDelete = (id: number) => {
        setSelectedId(id)
        setIsModalDeleteZNSProvider(true)
    }

    const closeModalDelete = () => {
        setSelectedId(undefined)
        setIsModalDeleteZNSProvider(false)
    }


    const onConfirmDelete = useThrottle(async () => {
        if (!selectedId) return
        pushLoading(true)
        const result = await deleteProvider(selectedId)
        if (result?.status) {
            pushToast(result.message, "success")
            closeModalDelete()
            gListZnsProvider()
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)


    useEffect(() => {
        if (isOpen) {
            if (!listProvider.length)
                gListZnsProvider()
        }

    }, [isOpen])
    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-4 w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Quản lý nhà cung cấp</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
            </div>}
            open={isOpen}
            onCancel={closeModal}
            centered
            className="w-modal modal-content-warning ant-modal-size"
            closeIcon={false}
            footer={''}
        >
            <ModalAddCreateZNSProvider
                isOpen={isModalAddZNSProvider}
                onSubmitFormModal={onSubmitFormModalAdd}
                closeModal={() => setIsModalAddZNSProvider(false)}
            />

            <ModalUpdateCreateZNSProvider
                isOpen={isModalUpdateZNSProvider}
                infoProvider={infoProvider}
                onSubmitFormModal={onSubmitFormModalUpdate}
                closeModal={() => setIsModalUpdateZNSProvider(false)}
            />

            <ModalDeleteManager
                isOpen={isModalDeleteZNSProvider}
                title="Bạn có chắc chắn xóa nhà cung cấp này"
                titleDelete="Xóa nhà cung cấp"
                content="Nhà cung cấp và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
                closeModal={closeModalDelete}
                onConfirm={onConfirmDelete}
            />

            <div className="custom-page-css flex flex-col  "
                style={{
                    maxHeight: '70vh',
                    overflowY: 'scroll'
                }}
            >
                <div className="custom-page-css flex flex-col gap-2 px-2 ">
                    <div className="custom-page-css flex items-center justify-between bg-FAFAFA py-2 px-4">
                        <Button className="custom-page-css text-096DD9 border-096DD9"
                            onClick={() => setIsModalAddZNSProvider(true)}
                        >
                            <span>Thêm</span>
                            <PlusOutlined />
                        </Button>
                        <span className="custom-page-css text-sm font-medium text-4B4B4B">Hành động</span>


                    </div>
                </div>
                {/* <div className="custom-page-css flex flex-col   py-2 px-4 h-full">
                    {
                        listProvider.map((item, index) => (
                            <div
                                key={item.id}
                                className={`custom-page-css flex items-center justify-between py-2 ${index === listProvider.length - 1 ? '' : ' border-b'}`}
                            >
                                <span
                                    className={`custom-page-css text-sm  px-2 py-1 rounded font-regular`}
                                >{item.zaloAppName ?? NO_DATA}</span>
                                <div className="custom-page-css flex items-center gap-2">
                                    <Switch
                                        size="small"
                                        // disabled={edit} 
                                        checked={!!item.status}
                                        onChange={() => handelActiveProvider(item.id)}
                                    />
                                    <div
                                        className={`custom-page-css flex items-center justify-center p-1 border rounded cursor-pointer ${checkDisabledPermission(edit)}`}
                                        onClick={() => gInfoProvider(item.id)}
                                    >
                                        <EditOutlined />
                                    </div>
                                    <div
                                        className={`custom-page-css flex items-center justify-center p-1 border rounded cursor-pointer text-FF4D4F ${checkDisabledPermission(isDelete)}`}
                                        onClick={() => openModalDelete(item.id)}
                                    >
                                        <DeleteOutlined />
                                    </div>
                                </div>

                            </div>
                        ))
                    }
                </div> */}
            </div>
        </Modal>
    )
}
export default ModalZNSSupplierManagement
